/** @format */

import React from 'react';
import update from 'immutability-helper';
import {
    onInputChange,
    onNumberInputChange,
    onIntNumberChange,
    onFloatNumberChange,
    onBooleanChange,
    onPhoneInputChange,
    onCheckboxChange,
    onChange
} from './handle_change';

export default function useForm(initialState) {
    const [formData, setFormData] = React.useState(initialState);

    const resetFormData = () => {
        setFormData(initialState);
    };

    const updateFormData = updateTarget => {
        setFormData(formData => update(formData, updateTarget));
    };

    const onFormUpdate = updateFormData.bind(this);

    const updateFormDataFunction = (parsingFunction, ...args) => {
        setFormData(update(formData, parsingFunction(...args)));
    };

    const onFormInputChange = updateFormDataFunction.bind(this, onInputChange);
    const onFormNumberInputChange = updateFormDataFunction.bind(this, onNumberInputChange);
    const onFormIntNumberChange = updateFormDataFunction.bind(this, onIntNumberChange);
    const onFormFloatNumberChange = updateFormDataFunction.bind(this, onFloatNumberChange);
    const onFormBooleanChange = updateFormDataFunction.bind(this, onBooleanChange);
    const onFormPhoneInputChange = updateFormDataFunction.bind(this, onPhoneInputChange);
    const onFormCheckboxChange = updateFormDataFunction.bind(this, onCheckboxChange);
    const onFormChange = updateFormDataFunction.bind(this, onChange);

    return {
        formData,
        setFormData,
        resetFormData,
        updateFormData,
        onFormUpdate,
        onFormInputChange,
        onFormNumberInputChange,
        onFormIntNumberChange,
        onFormFloatNumberChange,
        onFormBooleanChange,
        onFormPhoneInputChange,
        onFormCheckboxChange,
        onFormChange
    };
}
